var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4E7EF",
    d: "M9.125 10.125c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4E7EF",
    fillRule: "evenodd",
    d: "M12.8 2.225c-.4-.3-.95-.3-1.35 0l-9 6.75c-.497.373-.598 1.078-.225 1.575.373.497 1.078.598 1.575.225l.45-.338v10.688c0 .621.504 1.125 1.125 1.125h13.5c.621 0 1.125-.504 1.125-1.125V10.437l.45.338c.497.373 1.202.272 1.575-.225s.272-1.202-.225-1.575l-9-6.75zM6.5 20V8.75l5.625-4.219L17.75 8.75V20H15.5v-3.038c0-1.74-1.41-3.15-3.15-3.15h-.45c-1.74 0-3.15 1.41-3.15 3.15V20H6.5zm6.75-3.038V20H11v-3.038c0-.497.403-.9.9-.9h.45c.497 0 .9.403.9.9z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.57329bda34c846966ed06018ee6d9ad6.svg";
export { ForwardRef as ReactComponent };